import { useQuery } from "@tanstack/react-query";
import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'tasks';

export function useGetAllTasks(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetTask(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateTask() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateTask({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteTask({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
